/** @desc 提单页类型 */
export const billTypeMap = {
  fast: 1, // 快速发单
  upload: 2, // 上传发单
};

/** @desc 事件类型埋点（提单类型涉及埋点） */
export const billEventLogs = [
  'sailing_c_e_sidebar_retain_popup_sw',
  'sailing_c_e_sidebar_retain_popup_ck',
  'sailing_c_e_requestpage_info_common_sw',
  'sailing_c_e_requestpage_info_sender_common_sw',
  'sailing_c_e_requestpage_info_sender_common_ck',
  'sailing_c_e_requestpage_info_reciever_common_sw',
  'sailing_c_e_requestpage_info_reciever_goods_type_ck',
  'sailing_c_e_requestpage_info_reciever_goods_weight_ck',
  'sailing_c_e_requestpage_info_reciever_common_ck',
  'sailing_c_e_requestpage_info_history_list_sw',
  'sailing_c_e_requestpage_info_reciever_history_result_ck',
  'sailing_c_e_requestpage_info_reciever_delete_popup_ck',
  'sailing_c_e_requestpage_info_reciever_add_ck	',
  'sailing_c_e_requestpage_info_cart_common_sw',
  'sailing_c_e_requestpage_info_cart_exchange_payment_ck',
  'sailing_c_e_paylistpage_add_card_ck',
  'sailing_c_e_requestpage_info_cart_pay_ck',
  'sailing_c_e_requestpage_info_cart_pay_callback_ck',
  'sailing_c_e_requestpage_address_check_sw',
];

/** @desc 事件类型埋点（提单类型涉及埋点 UUID串联流程） */
export const billUuidLogs = [
  'sailing_c_e_requestpage_info_sender_common_sw',
  'sailing_c_e_requestpage_info_reciever_common_sw',
  'sailing_c_e_requestpage_info_cart_common_sw',
  'sailing_c_e_requestpage_info_cart_pay_ck',
  'sailing_c_e_requestpage_info_cart_pay_callback_ck',
];
